import { toaster } from "baseui/toast";
import moment from 'moment-timezone';
import axios from 'axios';
import jwt from "jsonwebtoken"
import * as service from '../../../services/Dashboard';
import * as authService from '../../../services/Auth';
import * as submitService from '../../../services/Submit';
import { CodeConstant, ButtonConstant, MessageConstant, ApiConstant } from "../../../constants";
import { pushLog2DV2LogServer } from "../../../services/logging";

const SETTINGS_V2_REDUCER_ACTIONS = {
    UPDATE_STATE_DATA: 'UPDATE_STATE_DATA',
    RESET_STATE_DATA: 'RESET_STATE_DATA',
};

const token = localStorage.getItem('token');
const decodedToken = jwt.decode(token);
const uid = decodedToken?.uid || null;

const getAccountInfo = (dispatch, showLoader = true) => {
    if (showLoader) {
        dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { loading: true } });
    }
    const promiseObj = service.getAccountInfo();
    promiseObj.then(res => {
        if (res.data.code === CodeConstant.OK) {
          dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: {
                emailSection: {
                    email: res.data.data.accountData.email,
                    currentEmail: res.data.data.accountData.email,
                },
                passwordExist: res.data.data.accountData.passwordExist,
                ssoAuth: res.data.data.accountData.ssoAuth,
                oerror_code: res.data.data.accountData.oerror_code,
                phoneSection: {
                    phone: res.data.data.accountData.phone_number,
                    phoneCountryCode: res.data.data.accountData.phone_country_code,
                    currentPhone: res.data.data.accountData.phone_number,
                },
            }});
        } else if (res.data.code === CodeConstant.BAD_REQUEST) {
          const data = res.data.data.accountData;
          if ('accountExist' in data && data.accountExist === 'false') {
            localStorage.clear();
          }
  
        } else if (res.data.code === CodeConstant.UNAUTHORIZED) {
          localStorage.clear();
        } else {
          toaster.negative("Something went wrong. Please try again later.", {});
        }
      }).catch(error => {
        toaster.negative("Something went wrong. Please try again later.", {});
      }).finally(() => {
        dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { loading: false } });
      })
};

const processEmailUpdate = (res, history) => {
  if (res.data.code === CodeConstant.OK || res.data.success) {
    toaster.positive('Your email address was updated successfully. Please log in with your new email.');
    window.localStorage.clear();
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common.authorization;
    setTimeout(() => {
      history.push("/login");
    }, 2000);
  } else if (res.data.code === CodeConstant.UNAUTHORIZED) {
    toaster.negative(res.data.message);
    history.push("/login");
  } else if (res.data.code === CodeConstant.FORBIDDEN) {
    toaster.negative(res.data.message);
  } else {
    toaster.negative(MessageConstant.CALL_API_ERROR);
  }
}

const updateEmail = (email, password, history, dispatch) => {
  const timezone = moment.tz.guess();
  const updateTime = moment().tz(timezone).format('Do MMM YYYY hh:mm:ss a z');
  let promiseObj = service.updateEmail({ email, password, updateTime });
  dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { emailSection: { isLoading: true } } });
  promiseObj.then(res => {
    pushLog2DV2LogServer.info('SETTINGS_PAGE', 'UPDATE_EMAIL_SUCCESS', {
      email: email,
      user_id: uid,
    }, {}, null);
    processEmailUpdate(res, history);
  }).catch(error => {
    pushLog2DV2LogServer.error('SETTINGS_PAGE', 'UPDATE_EMAIL_FAILED', {
      email: email,
      user_id: uid,
    }, {error: error.response.data.message, status: error.response.status}, null);
    toaster.negative(error.response.data.message);
  }).finally(() => {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { emailSection: { isLoading: false } } });
  })
}

const updatePwd = (currentPwd, confirmPwd, dispatch) => {
  dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { passwordSection: { isLoading: true } } });
  const updatePwdData = {
    oldPwd : currentPwd,
    newPwd : confirmPwd
  }

  let promiseObj = service.updatePassword(updatePwdData)
  promiseObj.then(res => {
    if (res.data.code === CodeConstant.OK) {
      toaster.positive('Your password was updated successfully.');
      pushLog2DV2LogServer.info('SETTINGS_PAGE', 'UPDATE_PASSWORD_SUCCESS', {
        uid: uid,
      }, {}, null);
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: {
        passwordSection: {
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
          isEditing: false,
        }
      }});
    } else if (res.data.code === CodeConstant.UNAUTHORIZED) {
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'UPDATE_PASSWORD_FAILED', {
        uid: uid,
      }, {error: res.data.message}, null);
      toaster.negative(res.data.message);
    } else {
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'UPDATE_PASSWORD_FAILED', {
        uid: uid,
      }, {error: MessageConstant.CALL_API_ERROR}, null);
      toaster.negative(MessageConstant.CALL_API_ERROR);
    }
  }).catch(error => {
    pushLog2DV2LogServer.error('SETTINGS_PAGE', 'UPDATE_PASSWORD_FAILED', {
      uid: uid,
    }, {error: MessageConstant.NETWORK_ERROR}, null);
    toaster.negative(MessageConstant.NETWORK_ERROR);
  }).finally(() => {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { passwordSection: { isLoading: false } } });
  })
}


const  handleSocialLogin = (data, dispatch) => {
  let promiseObj
  if (data.type === ButtonConstant.GOOGLE_SIGNIN){
    if (data.googleId === '') {
      promiseObj = authService.saveGoogleFailedStatus(data)
    } else {
      promiseObj = authService.saveGoogleData(data)
    }
  } else if (data.type === ButtonConstant.FACEBOOK_SIGNIN) {
    if (data.id === '') {
      promiseObj = authService.saveFacebookFailedStatus(data)
    } else {
      promiseObj = authService.saveFacebookData(data)
    }
  } else if (data.type === ButtonConstant.LINKEDIN_CONNECT) {
    promiseObj = submitService.submitLinkedinData(data)
  } else {
    promiseObj = submitService.submitGitHubData(data)
  }
  promiseObj.then(res => {
    if (res.data.code === CodeConstant.OK || res.data.code === CodeConstant.CREATED) {
      toaster.positive('Your social login is updated!');
      getAccountInfo(dispatch);
      pushLog2DV2LogServer.info('SETTINGS_PAGE', 'SOCIAL_LOGIN_SUCCESS', {
        uid: uid,
      }, {}, null);
    } else if (res.data.code === CodeConstant.UNAUTHORIZED) {
      toaster.negative(res.data.message);
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'SOCIAL_LOGIN_FAILED', {
        uid: uid,
      }, {error: res.data.message}, null);
    } else {
      toaster.negative(MessageConstant.CALL_API_ERROR);
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'SOCIAL_LOGIN_FAILED', {
        uid: uid,
      }, {error: MessageConstant.CALL_API_ERROR}, null);
    }
  }).catch(error => {
    toaster.negative(MessageConstant.NETWORK_ERROR);
    pushLog2DV2LogServer.error('SETTINGS_PAGE', 'SOCIAL_LOGIN_FAILED', {
      uid: uid,
    }, {error: error.message}, null);
  })
}

const FETCH_ALL_COUNTRIES = async (dispatch) => {
  try {
    const response = await service.getAllCountries();
    const excludedCountries = response.data.result.filter(country => country.is_ofac === 1).map(item => {
      return item.code ? item.code.toLowerCase() : null;
    });
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { excludedCountries } });

  } catch (e) {
    console.log(e);
  }
};

const updatePhone = async (phone, phone_country_code, password, dispatch) => {
  try {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { phoneSection: { isLoading: true } } });
    const response = await axios.post(
      `${ApiConstant.BASE_URL}onboarding`,
      {
        action: 'UPDATE_MOBILE_DATA',
        phone_number: phone,
        phone_country_code: phone_country_code,
        password,
        from_settings_page: true,
      }
    );
    if (response.data.success) {
      toaster.positive('Your phone number is updated!');
      pushLog2DV2LogServer.info('SETTINGS_PAGE', 'UPDATE_PHONE_SUCCESS', {
        uid: uid,
      }, {}, null);
    } else {
      toaster.negative(response.data.errorMessage || 'Something went wrong. Please try again later.');
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'UPDATE_PHONE_FAILED', {
        uid: uid,
      }, {error: response.data.errorMessage}, null);
    }
  } catch (e) {
    pushLog2DV2LogServer.error('SETTINGS_PAGE', 'UPDATE_PHONE_FAILED', {
      uid: uid,
    }, {error: MessageConstant.NETWORK_ERROR}, null);
    const errorMessage =  e.response?.data?.errorMessage || 'Something went wrong. Please try again later.'
    toaster.negative(errorMessage);
  } finally {
    await getAccountInfo(dispatch, false);
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { phoneSection: { isLoading: false } } });
  }
}

const responseGoogle = (response, dispatch) => {
  let googleData = {
    type: ButtonConstant.GOOGLE_SIGNIN,
    googleId: "",
    email: "",
    firstName: "",
    lastName: "",
  };
  if (response) {
    const token = response.credential || '';
    const decoded = jwt.decode(token);


    googleData = {
      type: ButtonConstant.GOOGLE_SIGNIN,
      googleId: decoded.sub || '',
      email: decoded.email || '',
      firstName: decoded.given_name || '',
      lastName: decoded.family_name || '',
      accessToken: token
    }; 
  }

  handleSocialLogin(googleData, dispatch);
}

const toGoodbye = () => {
  window.localStorage.clear();
  delete axios.defaults.headers.common.Authorization;
  delete axios.defaults.headers.common.authorization;
  window.localStorage.setItem("goodbye", "1");
  window.location = "/goodbye";
}

const deleteAccount = (password) => {
  pushLog2DV2LogServer.info('SETTINGS_PAGE', 'DELETE_ACCOUNT', {
    uid: uid,
  }, {}, null);
  return service.deleteAccount(password).then(result => result.data);
}

const checkDeleteStatus = (dispatch) => {
  axios.post(`${ApiConstant.BASE_URL}common-user/`, {
    action: 'GET_DELETE_STATUS',
  })
  .then(result => result.data)
  .then(result => {
    if (result.success) {
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { deleteAccount: { deleteStatus: result.status, progress: result.progress } } });
      if (result.status === "Done") {
        toGoodbye();
      }
    }
  })
}

const getEmailSubscriptionStatus = async (dispatch) => {
  try {
    const response = await axios.get(`${ApiConstant.BASE_URL}accounts/get-email-subscription-status`);
    if (response.data.success) {
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enableEmailCommunication: !response.data?.is_unsubscribed } });
    }    
  } catch (error) {
    console.log('Error in getEmailSubscriptionStatus>>>>>', error);
  }
}

const getPhoneCommunicationSubscriptionStatus = async (dispatch) => {
  try {
    const response = await axios.get(`${ApiConstant.BASE_URL}accounts/get-phone-communication-subscription-status`);
    if (response.data.success) {
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enablePhoneCommunication: !response.data?.is_unsubscribed } });
    }
  } catch (error) {
    console.log('Error in getPhoneCommunicationSubscriptionStatus>>>>>', error);
  }
}

const unsubscribeEmail = async (dispatch) => {
  try {
    const response = await axios.post(`${ApiConstant.BASE_URL}accounts/unsubscribe-email`);
    if (response.data.success) {
      toaster.positive('You will stop receiving email notifications');
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enableEmailCommunication: false } });
      pushLog2DV2LogServer.info('SETTINGS_PAGE', 'UNSUBSCRIBE_EMAIL_SUCCESS', {
        uid: uid,
      }, {}, null);
    } else {
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enableEmailCommunication: true } });
      toaster.negative(response.data.message);
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'UNSUBSCRIBE_EMAIL_FAILED', {
        uid: uid,
      }, {error: response.data.message}, null);
    }
  } catch (error) {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enableEmailCommunication: true } });
    pushLog2DV2LogServer.error('SETTINGS_PAGE', 'UNSUBSCRIBE_EMAIL_FAILED', {
      uid: uid,
    }, {error: MessageConstant.NETWORK_ERROR}, null);
  } finally {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { emailCommunicationUpdateLoading: false } });
  }
}

const resubscribeEmail = async (dispatch) => {
  try {
    const response = await axios.post(`${ApiConstant.BASE_URL}accounts/resubscribe-email`);
    if (response.data.success) {
      toaster.positive('You will start receiving email notifications');
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enableEmailCommunication: true } });
      pushLog2DV2LogServer.info('SETTINGS_PAGE', 'RESUBSCRIBE_EMAIL_SUCCESS', {
        uid: uid,
      }, {}, null);
    } else {
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enableEmailCommunication: false } });
      toaster.negative(response.data.message);
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'RESUBSCRIBE_EMAIL_FAILED', {
        uid: uid,
      }, {error: response.data.message}, null);
    }
  } catch (error) {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enableEmailCommunication: false } });
    pushLog2DV2LogServer.error('SETTINGS_PAGE', 'RESUBSCRIBE_EMAIL_FAILED', {
      uid: uid,
    }, {error: MessageConstant.NETWORK_ERROR}, null);
  } finally {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { emailCommunicationUpdateLoading: false } });
  }
}

const updatePhoneCommunicationSubscription = async (is_unsubscribed, dispatch) => {
  try {
    const response = await axios.post(`${ApiConstant.BASE_URL}accounts/update-phone-communication-subscription`, { is_unsubscribed });
    if (response.data.success) {
      const message = is_unsubscribed ? 'You will stop receiving phone notifications' : 'You will start receiving phone notifications';
      toaster.positive(message);
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enablePhoneCommunication: !is_unsubscribed } });
      pushLog2DV2LogServer.info('SETTINGS_PAGE', 'UPDATE_PHONE_COMMUNICATION_SUBSCRIPTION_SUCCESS', {
        uid: uid,
      }, {}, null);
    } else {
      dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enablePhoneCommunication: is_unsubscribed } });
      toaster.negative(response.data.message);
      pushLog2DV2LogServer.warn('SETTINGS_PAGE', 'UPDATE_PHONE_COMMUNICATION_SUBSCRIPTION_FAILED', {
        uid: uid,
      }, {error: response.data.message}, null);
    }
  } catch (error) {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { enablePhoneCommunication: is_unsubscribed } });
    pushLog2DV2LogServer.error('SETTINGS_PAGE', 'UPDATE_PHONE_COMMUNICATION_SUBSCRIPTION_FAILED', {
      uid: uid,
    }, {error: MessageConstant.NETWORK_ERROR}, null);
  } finally {
    dispatch({ type: SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA, payload: { phoneCommunicationUpdateLoading: false } });
  }
}


const SETTINGS_V2_ACTIONS = {
  ...SETTINGS_V2_REDUCER_ACTIONS,
  getAccountInfo,
  updateEmail,
  updatePwd,
  handleSocialLogin,
  FETCH_ALL_COUNTRIES,
  responseGoogle,
  updatePhone,
  deleteAccount,
  checkDeleteStatus,
  getEmailSubscriptionStatus,
  getPhoneCommunicationSubscriptionStatus,
  unsubscribeEmail,
  resubscribeEmail,
  updatePhoneCommunicationSubscription
};

export default SETTINGS_V2_ACTIONS;
